<terra-dialog-header>
    <h1 class="large-title">{{(!!context?.id ? 'Edit' : 'Add')}} Business Entity</h1>
</terra-dialog-header>
<mat-dialog-content>
    <div class="create-edit-company-body py-4">
        <form [formGroup]="pageForm" class="terra-error-style">

            <!-- Company name -->
            <div class="flex flex-column gap-1">
                <label for="txtCompanyName" class="text-input-label">Business entity name</label>
                <mat-form-field appearance="outline">
                    <input matInput id="txtCompanyName" formControlName="name" autocomplete="company-name"
                        class="lo_sensitive" placeholder="Business entity name" />
                    <mat-error *ngIf="pageForm.get('name').hasError('required')"> Required</mat-error>
                </mat-form-field>
            </div>

            <div class="full-width flex flex-column gap-1">
                <label class="text-input-label">Business entity type</label>
                <p-dropdown [options]="entityTypes" formControlName="entityType">
                    <ng-template let-selected pTemplate="selectedItem">
                        <span>{{ selected | enumString:EntityType }}</span>
                    </ng-template>
                    <ng-template let-entity pTemplate="item">
                        <div class="flex justify-content-between">
                            <span class="flex flex-wrap align-content-center">{{ entity | enumString:EntityType}}</span>
                        </div>
                    </ng-template>
                </p-dropdown>
            </div>
        </form>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <div class="flex align-items-center justify-content-center gap-2 py-4">
        <terra-buttons type="secondary" label="Cancel" (click)="cancel()"></terra-buttons>

        <terra-buttons type="primary" label="Save" (click)="save()"></terra-buttons>
    </div>
</mat-dialog-actions>
